import React from "react";
import { LuInfo } from "react-icons/lu";
import { Badge, Spinner } from "../../../components/ui";
import { t } from "../../../i18n";
import { AppealWizard } from "../useAppealWizard";

/** Passo 4: resumo do que vai para a IA antes de "Gerar recurso". */
export const ConfirmStep: React.FC<{ w: AppealWizard }> = ({ w }) => {
  const order = w.order!;
  const rows: [string, React.ReactNode][] = [
    [t("appeals.confirm.order"), `#${order.codigo}`],
    [t("appeals.confirm.patient"), order.paciente],
    [t("appeals.confirm.procedure"), order.procedimento],
    [t("appeals.confirm.date"), order.data],
    [
      t("appeals.confirm.items"),
      <ul className="flex flex-col gap-1">
        {w.selectedItems.map((i) => (
          <li key={i.id}>{i.tipo === "CODIGO" ? `${i.id} ${i.descricao}` : i.descricao}</li>
        ))}
      </ul>,
    ],
    [
      t("appeals.confirm.grounds"),
      <span className="flex flex-wrap gap-1.5">
        {w.activeGrounds.map((g) => (
          <Badge key={g} tone="primary">
            {t(`appeals.generated.${g === "bibliografia" ? "references" : g}`)}
          </Badge>
        ))}
      </span>,
    ],
  ];

  return (
    <>
      <p className="text-body text-fg-muted">{t("appeals.confirm.intro")}</p>
      {w.generating && (
        <div role="status" className="flex animate-fade-in flex-col items-center gap-2 rounded-card bg-primary-tint px-4 py-8 text-center">
          <span className="text-primary">
            <Spinner size={40} />
          </span>
          <strong className="text-heading font-semibold">{t("appeals.confirm.generatingTitle")}</strong>
          <span className="text-caption text-fg-muted">{t("appeals.confirm.generatingHint")}</span>
        </div>
      )}
      <dl className="grid grid-cols-kv gap-x-3.5 gap-y-2 text-body">
        {rows.map(([label, value]) => (
          <React.Fragment key={label}>
            <dt className="text-fg-muted">{label}</dt>
            <dd className="min-w-0 break-words font-medium">{value}</dd>
          </React.Fragment>
        ))}
      </dl>
      <p className="flex items-start gap-2 rounded-control bg-primary-tint px-3.5 py-3 text-caption text-fg-secondary">
        <LuInfo size={16} className="mt-0.5 shrink-0 text-primary" aria-hidden />
        {t("appeals.confirm.notice")}
      </p>
    </>
  );
};
